"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es7.object.entries");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _popupTypes = require("@/utils/popupTypes.js");
var _index = require("@/utils/index.js");
var _memberManagement = require("@/api/member/memberManagement.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityHomePopup',
  data: function data() {
    return {
      loading: false,
      activeTab: 'all',
      imagePrefix: '',
      searchForm: {
        param: '',
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        // 弹窗类型 3社区首页
        popType: _popupTypes.PopupTypes.POP_TYPE.COMMUNITY,
        status: ''
      },
      // 页面路径到页面名称的映射
      pageMap: new Map(),
      tableData: [],
      // CDP分组类型映射
      cdpGrpTypeMap: {
        0: '不匹配',
        1: 'CDP分组',
        2: '消费行为'
      },
      // CDP分组类型标签样式映射
      cdpGrpTypeTagMap: {
        0: 'info',
        1: 'success',
        2: 'warning'
      }
    };
  },
  methods: {
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.fetchList();
      this.getImagePrefix();
    },
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              console.log('获取图片前缀响应：', response);
              if (response.code === 200) {
                this.imagePrefix = response.data;
                console.log('获取图片前缀成功：', this.imagePrefix);
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀错误：', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取页面列表并构建映射
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                // 构建页面ID到页面名称的映射
                response.data.forEach(function (page) {
                  _this.pageMap.set(String(page.id), page.pageName);
                });
                console.log('页面映射构建成功:', this.pageMap);
              } else {
                console.error('获取页面列表失败:', response.message);
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取页面列表错误:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 标签页切换
    handleTabChange: function handleTabChange(value) {
      this.searchForm.type = value === 'all' ? '' : value;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 获取推荐内容
    getRecommendContent: function getRecommendContent(row) {
      // 类型3：recommendContentId 为页面ID，尝试获取对应的页面名称
      if (row.recommendType == 3) {
        var pageName = this.pageMap.get(row.recommendContentId != null ? String(row.recommendContentId) : null);
        if (pageName) {
          return this.appendParam(pageName, row);
        }
      }

      // 类型6-其他：recommendContent 为appid，recommendContentId 为跳转地址
      if (row.recommendContentId != null && row.recommendContent != null) {
        return this.appendParam(row.recommendContent + "/" + row.recommendContentId, row);
      } else if (row.recommendContentId != null) {
        return this.appendParam(row.recommendContentId, row);
      }
      return this.appendParam(row.recommendContent, row);
    },
    // 拼接参数
    appendParam: function appendParam(content, row) {
      if (content && row.recommendContentParam != null && row.recommendContentParam !== '') {
        return content + '?' + row.recommendContentParam;
      }
      return content;
    },
    // 获取数据
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      // 调用API获取数据
      (0, _popupConfig.getPopupConfigPage)(this.searchForm).then(function (response) {
        // 根据实际返回的数据结构调整
        if (response.records) {
          _this2.tableData = response.records.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              // 如果返回的数据字段名不匹配，需要进行转换
              startTime: item.showStartTime || item.startTime || '',
              endTime: item.showEndTime || item.endTime || '',
              isEnabled: item.isEnabled !== undefined ? item.isEnabled : false,
              isShow: item.isShow !== undefined ? item.isShow : true,
              sequence: item.recommendPriority || item.sequence || 0,
              image: item.showImage || item.image || '',
              type: _this2.getRecommendTypeString(item.recommendType) || item.type || '',
              // CDP分组相关字段
              cdpGrpType: item.cdpGrpType !== undefined ? item.cdpGrpType : 0,
              cdpGrpId: item.cdpGrpId || null
            });
          });
          _this2.searchForm.total = response.total || 0;
        } else {
          _this2.tableData = [];
          _this2.searchForm.total = 0;
        }
        _this2.loading = false;
      }).catch(function (error) {
        console.error('获取弹窗配置列表失败:', error);
        _this2.$message.error('获取弹窗配置列表失败');
        _this2.tableData = [];
        _this2.searchForm.total = 0;
        _this2.loading = false;
      });
    },
    // 保存或修改弹窗配置
    saveOrUpdatePopup: function saveOrUpdatePopup(popupData) {
      var _this3 = this;
      return (0, _popupConfig.saveOrUpdatePopupConfig)(popupData).then(function (response) {
        _this3.$message.success('保存成功');
        _this3.fetchList(); // 保存成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('保存弹窗配置失败:', error);
        _this3.$message.error('保存弹窗配置失败');
        throw error;
      });
    },
    // 删除弹窗配置
    removePopupConfig: function removePopupConfig(id) {
      var _this4 = this;
      return (0, _popupConfig.deletePopupConfig)(id).then(function (response) {
        _this4.$message.success('删除成功');
        _this4.fetchList(); // 删除成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('删除弹窗配置失败:', error);
        _this4.$message.error('删除弹窗配置失败');
        throw error;
      });
    },
    // 更新弹窗配置状态
    updatePopupStatus: function updatePopupStatus(id, isEnable) {
      var _this5 = this;
      return (0, _popupConfig.updatePopupConfigStatus)(id).then(function (response) {
        _this5.$message.success("\u5DF2".concat(isEnable ? '启用' : '禁用', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗配置状态失败:', error);
        _this5.$message.error('更新弹窗配置状态失败');
        // 恢复开关状态
        var popup = _this5.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isEnable = !isEnable;
        }
        throw error;
      });
    },
    // 更新弹窗展示状态
    updatePopupShowStatus: function updatePopupShowStatus(id, isShow) {
      var _this6 = this;
      return (0, _popupConfig.updatePopupShowStatus)(id).then(function (response) {
        _this6.$message.success("\u5DF2".concat(isShow ? '展示' : '隐藏', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗展示状态失败:', error);
        _this6.$message.error('更新弹窗展示状态失败');
        // 恢复开关状态
        var popup = _this6.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isShow = !isShow;
        }
        throw error;
      });
    },
    // 复制
    handleCopy: function handleCopy(row) {
      this.$emit('add-popup', 'communityHome', row.id);
    },
    // 添加弹框
    handleAdd: function handleAdd() {
      this.$emit('add-popup', 'communityHome');
    },
    // 处理保存成功事件
    handleSaved: function handleSaved() {
      this.fetchList();
    },
    // 状态切换
    handleStatusChange: function handleStatusChange(row) {
      this.updatePopupStatus(row.id, row.isEnable);
    },
    // 展示状态切换
    handleShowChange: function handleShowChange(row) {
      this.updatePopupShowStatus(row.id, row.isShow);
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      // 传递编辑数据给父组件
      this.$emit('edit-popup', 'communityHome', row.id);
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this7 = this;
      this.$confirm('确定要移除此弹窗配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.removePopupConfig(row.id);
      }).catch(function () {
        _this7.$message.info('已取消移除');
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    // 获取类型标签样式
    getTypeTagType: function getTypeTagType(type) {
      var recommendType = this.getRecommendTypeByString(type);
      return _popupTypes.RecommendTypeTagMap[recommendType] || '';
    },
    // 获取类型文本
    getTypeText: function getTypeText(type) {
      var recommendType = this.getRecommendTypeByString(type);
      return _popupTypes.RecommendTypeTextMap[recommendType] || type;
    },
    // 根据推荐类型值获取字符串
    getRecommendTypeString: function getRecommendTypeString(recommendType) {
      return _popupTypes.RecommendTypeTextMap[recommendType] || '未知类型';
    },
    // 根据字符串获取推荐类型
    getRecommendTypeByString: function getRecommendTypeByString(typeString) {
      // 反向映射，从字符串获取推荐类型值
      for (var _i = 0, _Object$entries = Object.entries(_popupTypes.RecommendTypeTextMap); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value === typeString) {
          return parseInt(key);
        }
      }
      // 如果没有找到匹配的，尝试直接映射
      var directMap = {
        'coupon': _popupTypes.PopupTypes.RECOMMEND_TYPE.COUPON,
        'system': _popupTypes.PopupTypes.RECOMMEND_TYPE.ACTIVITY,
        'direct': _popupTypes.PopupTypes.RECOMMEND_TYPE.DIRECT,
        'survey': _popupTypes.PopupTypes.RECOMMEND_TYPE.SURVEY,
        'external': _popupTypes.PopupTypes.RECOMMEND_TYPE.EXTERNAL,
        'wechat': _popupTypes.PopupTypes.RECOMMEND_TYPE.WECHAT
      };
      return directMap[typeString] || _popupTypes.PopupTypes.RECOMMEND_TYPE.COUPON;
    },
    // 获取分组类型标签样式
    getCdpGrpTypeTagType: function getCdpGrpTypeTagType(cdpGrpType) {
      return this.cdpGrpTypeTagMap[cdpGrpType] || 'info';
    },
    // 获取分组类型文本
    getCdpGrpTypeText: function getCdpGrpTypeText(cdpGrpType) {
      return this.cdpGrpTypeMap[cdpGrpType] || '不匹配';
    }
  },
  mounted: function mounted() {
    this.fetchList();
    // 获取图片前缀
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
  }
};